<template>
  <div>
    <Hero :title="moduleData.title" />
    <PressContent :content="articleContent" />
  </div>
</template>

<script>
import { Hero, PressContent } from './components'

export default {
  name: 'PressReleaseModule',

  components: {
    Hero,
    PressContent,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    articleContent() {
      const data = this.moduleData
      return {
        article: {
          image: data.article_illustration,
          intro: data.article_introduction,
          body: data.body,
        },
        sidebar: {
          date: data.date,
          title: data.article_title,
        },
      }
    },
  },

  methods: {},
}
</script>

<style lang="scss" module></style>
